/**
 * The phone's side of the video rules (services/api/src/lesson-videos/
 * video-rules.ts holds the API's). Two per lesson; 30 seconds, with half a
 * second for phones that round a 30-second clip up.
 */
export const PLACES_PER_LESSON = 2;
export const MAX_SECONDS = 30.5;
